import React from 'react';
import { FaInstagram, FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import bgImage from "../assets/images/socialsection.webm";
import '../styles/socialsection.css';
import whatsapp from "../assets/images/whatsappqr.jfif";

const SocialSection = () => {
  const phoneNumber = "917992151205";
  const message = "Hi BioSurge! I am interested in your products. Can you help me with the order?";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  return (
    <section className="social-hero-wrapper">
      <div className="container py-5">
        <div className="row align-items-center gy-5">

          {/* LEFT SIDE: Content */}
          <div className="col-lg-7">
            <div className="content-box">
              <h1 className="display-3 fw-bold main-title">
                Connect With <span className="highlight">BIOSURGE</span>
              </h1>
              <p className="lead subtitle mb-5">
                {/* Join our community to get daily health tips, exclusive offers, 
                and be the first to know about our new Ayurvedic launches. */}
                Join our wellness community for simple health tips, exclusive offers,
                and early access to our upcoming Ayurvedic blends.
              </p>

              {/* SOCIAL MEDIA BUTTONS */}
              <div className="d-flex flex-wrap gap-3 mb-5">
                <a href="https://instagram.com/biosurge_official" target="_blank" rel="noreferrer" className="social-btn insta">
                  <FaInstagram className="me-2" /> Instagram
                </a>
                <a href="https://www.facebook.com/profile.php?id=61588395567640" target="_blank" rel="noreferrer" className="social-btn fb">
                  <FaFacebookF className="me-2" /> Facebook
                </a>
                <button onClick={() => window.open(whatsappLink, '_blank')} target="_blank" rel="noreferrer" className="social-btn wa">
                  <FaWhatsapp className="me-2" /> WhatsApp
                </button>
              </div>

              {/* QR SCAN SECTION */}
              <div className="d-flex align-items-center gap-3 qr-section">
                <div className="qr-box">
                  {/* QR Placeholder Icon or Image */}
                  <img src={whatsapp} alt="QR" className="img-fluid" />
                </div>
                <div>
                  <h5 className="mb-0 fw-bold text-white">Scan to Connect</h5>
                  <p className="small text-muted mb-0">Get instant support on mobile</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE: Video/Animation */}
          <div className="col-lg-5">
            <div className="video-container floating-anim">
              <div className="glow-effect"></div>
              <video
                src={bgImage}
                autoPlay
                muted
                loop
                playsInline
                className="img-fluid rounded-4 shadow-lg border-dark-subtle border"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SocialSection;